const getSessionStorageKey = (id, type) => `table_${id}_${type}`;

export const loadFromSessionStorage = (id, type, defaultValue) => {
  if (!id) return defaultValue;

  try {
    const key = getSessionStorageKey(id, type);
    const stored = sessionStorage.getItem(key);
    if (!stored) return defaultValue;

    const parsed = JSON.parse(stored);

    if ((type === 'disabledFilters' || type === 'highlightedRows') && Array.isArray(parsed)) {
      return new Set(parsed);
    }

    return parsed;
  } catch (error) {
    console.warn(`Failed to load ${type} from session storage:`, error);
    return defaultValue;
  }
};

export const saveToSessionStorage = (id, type, value) => {
  if (!id) return;

  try {
    const key = getSessionStorageKey(id, type);
    const valueToStore = value instanceof Set ? Array.from(value) : value;
    sessionStorage.setItem(key, JSON.stringify(valueToStore));
  } catch (error) {
    console.warn(`Failed to save ${type} to session storage:`, error);
  }
};
